<template>


  <div class="grid-main bg-purple ">
    <h2 style="float: left">考核项列表</h2>
    <el-button type="primary" @click="dialogscoreAdd=true">添加指标项</el-button>
    <div class="table-box" >

      <el-table
        :data="scoreList.list"
        height="550"
        border
        style="width: 100%;">
        <el-table-column
          prop="scoreItemId"
          label="序号"
          width="180">
        </el-table-column>
        <el-table-column
          prop="scoreTypeName"
          label="指标类别"
          width="180">
        </el-table-column>
        <el-table-column
          prop="scoreItem"
          label="指标项"
          width="180">
        </el-table-column>
        <el-table-column
          prop="scoreValue"
          label="分值"
          width="180">
        </el-table-column>


        <el-table-column
          fixed="right"
          label="操作">
          <template slot-scope="scope">
            <el-button
            	type="success"
              size="mini"
              @click="openscore(scope.row.scoreItemId)">编辑</el-button>
            <el-button

              size="mini"
              type="danger"
              @click="openDelete(scope.row.scoreItemId)">删除</el-button>

          </template>
        </el-table-column>

      </el-table>
      <el-pagination
      	v-if="scoreList.scoreListtotal>10"
        background
        layout="prev, pager, next"
        :page-size="scoreList.scorepageSize"
        @current-change="setselectscorelist"
        :total="scoreList.scoreListtotal">

      </el-pagination>
    </div>



  <!--企业修改-->

  <el-dialog  :visible.sync="dialogscoreAdd" :before-close="dialogrolscoreclose">
    <el-form ref="form"  label-width="180px">
      <el-form-item label="选择指标类别：">
        <el-select v-model="scoreItemAdds.scoreTypeId" placeholder="请选择" style="float: left;">
          <el-option
            v-for="item in scoreTypeSelectAll"
            :key="item.id"
            :label="item.scoreTypeName"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="指标项名称：">
        <el-input v-model="scoreItemAdds.scoreItem" type="text" placeholder="请输入指标项名称："></el-input>
      </el-form-item>


      <el-form-item label="指标项分值：">
        <el-input v-model="scoreItemAdds.scoreValue" type="text" placeholder="请输入指标项分值："></el-input>
      </el-form-item>
      <el-form-item label="是否需要文件：">
        <el-radio v-model="scoreItemAdds.needFile" :label="1"  style="float: left;line-height: 41px;height: 41px;" >是</el-radio>
        <el-radio v-model="scoreItemAdds.needFile" :label="2"  style="float: left;line-height: 41px;height: 41px;">否</el-radio>
      </el-form-item>
      <el-form-item label="分值及计算方式：">
        <el-input v-model="scoreItemAdds.description" type="textarea" resize="none" :rows="10"   placeholder="请输入分值及计算方式："></el-input>
      </el-form-item>

      <el-form-item>

        <el-button type="primary" @click="scoreItemAdd()">确认提交</el-button>

      </el-form-item>
    </el-form>
  </el-dialog>



  <el-dialog :visible.sync="dialogupdatscore" :before-close="dialogrolscoreclose">
    <el-form ref="form"  label-width="180px">
      <el-form-item label="选择指标类别：">
        <el-select v-model="updatescoreItem.scoreTypeId" placeholder="请选择" style="float: left;">
          <el-option
            v-for="item in scoreTypeSelectAll"
            :key="item.id"
            :label="item.scoreTypeName"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="指标项名称：">
        <el-input v-model="updatescoreItem.scoreItem" type="text"  placeholder="请输入指标项名称："></el-input>
      </el-form-item>


      <el-form-item label="指标项分值：">
        <el-input v-model="updatescoreItem.scoreValue" type="text" placeholder="请输入指标项分值："></el-input>
      </el-form-item>
      <el-form-item label="是否需要文件：">
        <el-radio v-model="updatescoreItem.needFile" :label="1"  style="float: left;line-height: 41px;height: 41px;" >是</el-radio>
        <el-radio v-model="updatescoreItem.needFile" :label="2"  style="float: left;line-height: 41px;height: 41px;">否</el-radio>
      </el-form-item>
      <el-form-item label="分值及计算方式：">
        <el-input v-model="updatescoreItem.description" type="textarea" resize="none" :rows="10"   placeholder="请输入分值及计算方式："></el-input>
      </el-form-item>

      <el-form-item>

        <el-button type="primary" @click="updatescore()">确认提交</el-button>

      </el-form-item>
    </el-form>
  </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Score",
  data(){
    return {
      //指标项
      scoreList:{
        list:[],
        scoreListpage:1,
        scoreListtotal:0,
        scorepageSize:10
      },
      //新增指标项
      scoreItemAdds:{
        scoreTypeId:'',
        scoreItem:'',
        needFile:1,
        scoreValue:'',
        description:'',
      },
      dialogscoreAdd:false,
      scoreTypeSelectAll:{},
      ScoreItemAll:{},
      dialogupdatscore:false,
      updatescoreItem:{
        scoreTypeId:'',
        scoreItem:'',
        needFile:1,
        scoreValue:'',
        description:'',
      },


    }
  },
  beforeRouteEnter(to,from,next){

    next((vm)=>{

    });
  },
  created(){

  },
  mounted () {
    this.selectscorelist();
    this.selectscoreTypeSelectAll();
  },
  methods: {
    dialogrolscoreclose(){
      this.dialogupdatscore=false;
      this.updatescoreItem={
        scoreTypeId:'',
        scoreItem:'',
        needFile:1,
        scoreValue:'',
        description:'',
      };
      this.dialogscoreAdd=false
      this.scoreItemAdds={
        scoreTypeId:'',
        scoreItem:'',
        needFile:1,
        scoreValue:'',
        description:'',
      };
    },
    //考核项

    selectscorelist(){
      let that = this;
      let scoredata = {
        page:this.scoreList.scoreListpage,
        pageSize:this.scoreList.scorepageSize
      }
      this.$axios.defaults.withCredentials=true;
      this.$axios
        .post('/api/scoreItem/selectScoreItem',scoredata)
        .then(function (res) {

          if(res.data.code==200){
            that.scoreList.list = res.data.data.list;
            that.scoreList.scoreListtotal = res.data.data.total;
          }else{
            that.$message.error(res.data.msg);
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },

    setselectscorelist(scoreListpage){
      this.scoreList.scoreListpage = scoreListpage;
      this.selectscorelist();
    },

    //新增考核项
    scoreItemAdd(){
      let that = this;

      if (that.scoreItemAdds.scoreTypeId == '') {
        that.$message.error('请选择指标类别');
        return false;
      }
      if (that.scoreItemAdds.scoreItem == '') {
        that.$message.error('请输入指标项名称');
        return false;
      }
      if (that.scoreItemAdds.scoreValue == '') {
        that.$message.error('请输入指标项分值');
        return false;
      }
      if (that.scoreItemAdds.description == '') {
        that.$message.error('请输入分值及计算方式');
        return false;
      }
      let scoreItemdata = {
        scoreTypeId:that.scoreItemAdds.scoreTypeId,
        scoreItem:that.scoreItemAdds.scoreItem,
        needFile:that.scoreItemAdds.needFile,
        scoreValue:that.scoreItemAdds.scoreValue,
        description:that.scoreItemAdds.description,
      }
      this.$axios
        .post('/api/scoreItem/scoreItemAdd', scoreItemdata)
        .then(function (res) {
          if (res.data.code == 500) {
            that.$message.error("新增指标项失败:"+res.data.msg);
            return false;
          } else if (res.data.code == 200) {
            that.$message({
              message: '新增指标项成功',
              type: 'success'
            });
            //  this.show == true;
            window.setTimeout(() => {
              location.reload();
            }, 1000);
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });


    },
    selectscoreTypeSelectAll(){
      let that = this;
      this.$axios
        .get('/api/scoreType/scoreTypeSelectAll')
        .then(function (res) {
          if(res.data.code == 200){
            that.scoreTypeSelectAll = res.data.data;

          }

        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },
    selectScoreItemById(){

      let that = this;

      let updatescoreItemiddata = {
        id:that.scoreId
      }
      this.$axios
        .post('/api/scoreItem/selectScoreItemById', updatescoreItemiddata)
        .then(function (res) {
          that.updatescoreItem.scoreTypeId=res.data.data.scoreTypeId;
          that.updatescoreItem.scoreItem=res.data.data.scoreItem;
          that.updatescoreItem.needFile=res.data.data.needFile;
          that.updatescoreItem.scoreValue=res.data.data.scoreValue;
          that.updatescoreItem.description=res.data.data.description;
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },
    openscore(scoreId){

      this.scoreId = scoreId;

      this.selectScoreItemById();
      window.setTimeout(() => {
        this.dialogupdatscore = true;
      },100);


    },
    //修改企业信息
    updatescore(){
      let that = this;
      if (that.updatescoreItem.scoreTypeId == '') {
        that.$message.error('请选择指标类别');
        return false;
      }
      if (that.updatescoreItem.scoreItem == '') {
        that.$message.error('请输入指标项名称');
        return false;
      }
      if (that.updatescoreItem.scoreValue == '') {
        that.$message.error('请输入指标项分值');
        return false;
      }
      if (that.updatescoreItem.description == '') {
        that.$message.error('请输入分值及计算方式');
        return false;
      }

      let updatescoreItemdata = {
        scoreItemId:that.scoreId,
        scoreTypeId:that.updatescoreItem.scoreTypeId,
        scoreItem:that.updatescoreItem.scoreItem,
        needFile:that.updatescoreItem.needFile,
        scoreValue:that.updatescoreItem.scoreValue,
        description:that.updatescoreItem.description,
      }
      this.$axios
        .post('/api/scoreItem/updateScoreItem', updatescoreItemdata)
        .then(function (res) {
          if (res.data.code == 500) {
            that.$message.error("修改指标项失败:"+res.data.msg);
            return false;
          } else if (res.data.code == 200) {
            that.$message({
              message: '修改指标项成功',
              type: 'success'
            });
            window.setTimeout(() => {
              location.reload();
            }, 1000);

          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },



    openDelete(scoreId) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteScoreItem(scoreId)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //删除企业信息
    deleteScoreItem(scoreId){
      let that = this;
      let scoreIds = {
        scoreItemIds:[]
      }
      scoreIds.scoreItemIds.push(scoreId);
      this.$axios
        .post('/api/scoreItem/batchDeleteScoreItem',scoreIds)
        .then(function (res) {

          if(res.data.code==200){
            that.$message({
              message: '删除成功',
              type: 'success'
            });
            window.setTimeout(() => {
              location.reload();
            }, 1000);
          }else{
            that.$message.error(res.data.msg);
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },
  },
  watch: {

  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/admin/Score.vue